<template>
  <div id="EnergyConfig">
    <div class="title">
      <div>系统参数设置</div>
    </div>
    <div class="table-box">
      <el-form :rules="rules" ref="EnergyConfig" class="clearfix" :model="ruleForm" :disabled="false">
        <p class="item-title">能源定额属性设置</p>
        <el-form-item prop="monthElectricityQuota" label="用电定额：" autocomplete="off" style="margin-left: 28px;">
          <el-col :span="16"><el-input v-model="ruleForm.monthElectricityQuota" @input="inputChange('monthElectricityQuota')"></el-input></el-col>
          <el-col :span="3" style="text-align: center;color: #A1A1A1;">kW·h</el-col>
        </el-form-item>
        <el-form-item prop="monthWaterQuota" label="用水定额：" autocomplete="off" style="margin-left: 28px;">
          <el-col :span="16"><el-input v-model="ruleForm.monthWaterQuota" @input="inputChange('monthWaterQuota')"></el-input></el-col>
          <el-col :span="3" style="text-align: center;color: #A1A1A1;">m3</el-col>
        </el-form-item>
        <el-form-item prop="monthGasQuota" label="用气定额：" autocomplete="off" style="margin-left: 28px;">
          <el-col :span="16"><el-input v-model="ruleForm.monthGasQuota" @input="inputChange('monthGasQuota')"></el-input></el-col>
          <el-col :span="3" style="text-align: center;color: #A1A1A1;">m3</el-col>
        </el-form-item>
        <el-form-item prop="monthThermalQuota" label="用热定额：" autocomplete="off" style="margin-left: 28px;">
          <el-col :span="16"><el-input v-model="ruleForm.monthThermalQuota" @input="inputChange('monthThermalQuota')"></el-input></el-col>
          <el-col :span="3" style="text-align: center;color: #A1A1A1;">GJ</el-col>
        </el-form-item>
        <p class="item-title">电价设置</p>
        <el-form-item prop="priceKWH" label="单价：" autocomplete="off" style="margin-left: 28px;">
          <el-col :span="18"><el-input v-model="ruleForm.priceKWH" @input="inputChange('priceKWH')"></el-input></el-col>
          <el-col :span="3" style="text-align: center;color: #A1A1A1;">元</el-col>
        </el-form-item>
      </el-form>
      <div class="btn" >
        <el-button type="primary" @click="save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  var validateMax = (rule, value, callback) =>{
      if(value==0){
          callback();
      }else if (value >1000000000000 || value < -1 || value === '') {
          callback(new Error('请输入0~1000000000000的整数'));
      }else {
          callback();
      }
  }
  export default {
    data() {
      return {
        ruleForm: {
          monthElectricityQuota:null,
          monthWaterQuota:null,
          monthGasQuota:null,
          monthThermalQuota:null,
          priceKWH:null,
        },
        rules: {
          monthElectricityQuota:[{ required: false, message: '请输入电气定额', trigger: 'blur' },{ validator: validateMax, required: false, trigger: 'blur' }],
          monthWaterQuota:[{ required: false, message: '请输入用水定额', trigger: 'blur' },{ validator: validateMax, required: false, trigger: 'blur' }],
          monthGasQuota:[{ required: false, message: '请输入用气定额', trigger: 'blur' },{ validator: validateMax, required: false, trigger: 'blur' }],
          monthThermalQuota:[{ required: false, message: '请输入用热定额', trigger: 'blur' },{ validator: validateMax, required: false, trigger: 'blur' }],
          priceKWH:[{ required: false, message: '请输入电价', trigger: 'blur' },{ validator: validateMax, required: false, trigger: 'blur' }],
        },
        fullscreenLoading:false
      }
    },
    created() {
      this.$store.state.energyIndex = '/Energy/EnergyConfig'
      this.getConfig()
    },
    methods: {
      getConfig(){
        this.get('/EnergyConfig/getConfig',{companyId:this.$store.state.companyId}).then(res=>{
          if(res.success){
            for(let obj of res.result){
              this.ruleForm[obj.name] = obj.value
            }
          }else{
            this.$message({
              type:'warning',
              message:"获取配置失败：" + res.message
            })
          }
        })
      },
      inputChange(key){
        this.ruleForm[key] = this.ruleForm[key].replace(/[^\-?\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g,"");
      },
      save(){
        let id = this.$store.state.companyId
        this.$refs.EnergyConfig.validate((valid) => {
          if(valid){
            this.saveData1(id)
            this.fullscreenLoading = true
          }
        })
      },
      saveData1(id){
        this.post('/EnergyConfig/setConfig',{companyId:id,name:"monthElectricityQuota",value:this.ruleForm.monthElectricityQuota||''}).then(res=>{
          if(res.success){
            this.saveData2(id)
          }else{
            this.fullscreenLoading = false
            this.$message({
              type:'warning',
              message:"配置失败：" + res.message
            })
          }
        })
      },
      saveData2(id){
        this.post('/EnergyConfig/setConfig',{companyId:id,name:"monthWaterQuota",value:this.ruleForm.monthWaterQuota||''}).then(res=>{
          if(res.success){
            this.saveData3(id)
          }else{
            this.fullscreenLoading = false
            this.$message({
              type:'warning',
              message:"配置失败：" + res.message
            })
          }
        })
      },
      saveData3(id){
        this.post('/EnergyConfig/setConfig',{companyId:id,name:"monthGasQuota",value:this.ruleForm.monthGasQuota||''}).then(res=>{
          if(res.success){
            this.saveData4(id)
          }else{
            this.fullscreenLoading = false
            this.$message({
              type:'warning',
              message:"配置失败：" + res.message
            })
          }
        })
      },
      saveData4(id){
        this.post('/EnergyConfig/setConfig',{companyId:id,name:"monthThermalQuota",value:this.ruleForm.monthThermalQuota||''}).then(res=>{
          if(res.success){
            this.saveData5(id)
          }else{
            this.fullscreenLoading = false
            this.$message({
              type:'warning',
              message:"配置失败：" + res.message
            })
          }
        })
      },
      saveData5(id){
        this.post('/EnergyConfig/setConfig',{companyId:id,name:"priceKWH",value:this.ruleForm.priceKWH||''}).then(res=>{
          if(res.success){
            this.fullscreenLoading = false
            this.$message({
              type:'success',
              message:"配置成功"
            })
          }else{
            this.fullscreenLoading = false
            this.$message({
              type:'warning',
              message:"配置失败：" + res.message
            })
          }
        })
      },
    }
  }
</script>

<style scoped>
  .btn{
    text-align: center;
  }
  .item-title{
    font-size: 14px;
    margin-bottom: 20px;
  }
  .table-box {
    width: 500px;
    padding: 20px;
    background-color: #ffffff;
    text-align: left;
    margin-left: 20px;
  }
  .title {
    text-align: left;
    font-size: 14px;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Energy/EnergyConfig.vue